<script setup>
import { computed, ref, onMounted } from 'vue'
import {
  mdiAccountMultiple,
  mdiCartOutline,
  mdiChartTimelineVariant,
  mdiMonitorCellphone,
  mdiReload,
  mdiGithub,
  mdiChartPie,
  mdiBottleTonicOutline,
  mdiScent,
  mdiLinkBox
} from '@mdi/js'
import * as chartConfig from '@/components/Charts/chart.config.js'
import LineChart from '@/components/Charts/LineChart.vue'
import SectionMain from '@/components/SectionMain.vue'
import CardBoxWidget from '@/components/CardBoxWidget.vue'
import CardBox from '@/components/CardBox.vue'
import TableSampleClients from '@/components/TableSampleClients.vue'
import NotificationBar from '@/components/NotificationBar.vue'
import BaseButton from '@/components/BaseButton.vue'
import CardBoxTransaction from '@/components/CardBoxTransaction.vue'
import CardBoxClient from '@/components/CardBoxClient.vue'
import LayoutAuthenticated from '@/layouts/LayoutAuthenticated.vue'
import SectionTitleLineWithButton from '@/components/SectionTitleLineWithButton.vue'
import SectionBannerStarOnGitHub from '@/components/SectionBannerStarOnGitHub.vue'
import TableDevices from '@/components/TableDevices.vue'
import { getDevices, getDevicesByList, getDeviceStats } from '@/orm'
import { useMainStore } from '@/stores/main'

const mainStore = useMainStore()
const emptyUnits = ref(0)
const onlineCount = ref(0)
const deviceCount = ref(0)
const items = ref([])
const loading = ref(true)

const fetchData = async ()  => {
  let querySnapshot = null
  const customer = mainStore.customer
  if (customer) {
      const devicelist = mainStore.deviceList
      querySnapshot = await getDevicesByList(devicelist)

      const deviceStats = await getDeviceStats(devicelist)
      emptyUnits.value = deviceStats.countLowFragrance
      onlineCount.value = deviceStats.countLastData
      deviceCount.value = querySnapshot.length
  } else {
      querySnapshot = await getDevices()
  }
  items.value = querySnapshot.map(doc => ({
      id: doc.id,
      ...doc.data(),
  }))
  loading.value = false
}

onMounted(() => {
  fetchData()
})

//const clientBarItems = computed(() => mainStore.clients.slice(0, 4))
//const transactionBarItems = computed(() => mainStore.history)
</script>

<template>
  <LayoutAuthenticated>
    <SectionMain>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 mb-6">
        <CardBoxWidget
          trend="Overflow"
          trend-type="alert"
          color="text-red-500"
          :icon="mdiBottleTonicOutline"
          :number="emptyUnits"
          label="Empty units"
        />
        <CardBoxWidget
          trend="Steady"
          trend-type="steady"
          color="text-emerald-500"
          :icon="mdiLinkBox"
          :number="onlineCount"
          label="Active devices"
        />
        <CardBoxWidget
          trend="1%"
          trend-type="up"
          color="text-blue-500"
          :icon="mdiScent"
          :number="deviceCount"
          label="Devices"
        />
      <!--
        <CardBoxWidget
          trend="1%"
          trend-type="up"
          color="text-emerald-500"
          :icon="mdiAccountMultiple"
          :number="0"
          label="Clients"
        />
      -->
      </div>

      <SectionTitleLineWithButton :icon="mdiBottleTonicOutline" title="Empty units" />

      <CardBox class="mb-6" has-table>
        <TableDevices checkable />
      </CardBox>

    </SectionMain>
  </LayoutAuthenticated>
</template>
